module.exports = __webpack_public_path__ + "img/104054.ac5ab782.png";